import React from 'react'

// import logo from '../assets/images/website-icon.png'
import logo from '../assets/images/logo.svg'

class Header extends React.Component {
    render() {
        return (
            <section id="header">
                <div className="inner">
                    <span><img src={logo} alt="" width="120px" height="120px"/></span>
                    <h1><strong>Sumlook Production</strong></h1>
                    <p>Innovation to make your life better.</p>
                    <ul className="actions">
                        <li><a href="#about_us" className="button scrolly">About Us</a></li>
                    </ul>
                </div>
            </section>
        )
    }
}

export default Header
